import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="24"
    height="19"
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41667 9.5C2.41667 6.81667 3.95 4.51667 6.25 3.4625V1.35417C2.89583 2.6 0.5 5.7625 0.5 9.5C0.5 13.2375 2.89583 16.4 6.25 17.6458V15.5375C3.95 14.4833 2.41667 12.1833 2.41667 9.5ZM14.875 0.875C10.0833 0.875 6.25 4.70833 6.25 9.5C6.25 14.2917 10.0833 18.125 14.875 18.125C19.6667 18.125 23.5 14.2917 23.5 9.5C23.5 4.70833 19.6667 0.875 14.875 0.875ZM19.6667 10.4583H15.8333V14.2917H13.9167V10.4583H10.0833V8.54167H13.9167V4.70833H15.8333V8.54167H19.6667V10.4583Z"
      fill="#222A5C"
    />
  </svg>,
  "Budgets"
);
